import chroma from 'chroma-js';

export type FeaColorConfigType = 'SpectralScale' | 'CustomScale' | 'SingleColor' | 'None';

export abstract class FeaColorConfiguration {
  protected colorFunction?: (value: number) => chroma.Color;
  protected defaultValue: string;
  protected type: FeaColorConfigType;

  constructor(defaultValue: string = '#808080') {
    this.defaultValue = defaultValue;
  }

  public abstract getColor(value: number): string;
}

export class FeaSpectralColorConfiguration extends FeaColorConfiguration {
  private domain: number[];

  constructor(domain: number[], defaultValue: string = '#808080') {
    super(defaultValue);
    this.type = 'SpectralScale'
    this.domain = domain;
    this.colorFunction = chroma.scale("Spectral").domain(domain);
  }

  public getColor(value: number): string {
    if (Number.isNaN(value)) {
      return this.defaultValue;
    }
    let adjustedValue = value;
    const domainSize = this.domain[this.domain.length - 1] - this.domain[0] + 1; // very simplistic implementation for now. works well for very limited cases
    if (Number.isInteger(adjustedValue) && Number.isInteger(domainSize)) {
      adjustedValue = adjustedValue % domainSize;
    }
    return this.colorFunction ? this.colorFunction(adjustedValue).hex() : this.defaultValue;
  }
}

export class FeaSingleColorConfiguration extends FeaColorConfiguration {
  constructor(color: string, defaultValue: string = '#808080') {
    super(defaultValue);
    this.type = 'SingleColor'
    this.colorFunction = () => chroma(color);
  }

  public getColor(value: number): string {
    if (Number.isNaN(value)) {
      return this.defaultValue;
    }
    return this.colorFunction ? this.colorFunction(value).hex() : this.defaultValue;
  }
}

export class FeaCustomScaleColorConfiguration extends FeaColorConfiguration {
  constructor(colors: Map<string, number>, defaultValue: string = '#808080') {
    super(defaultValue);
    this.type = 'CustomScale'
    const scaleColors = [...colors.keys()];
    const domainValues = [...colors.values()];
    this.colorFunction = chroma.scale(scaleColors).domain(domainValues);
  }

  public getColor(value: number): string {
    if (Number.isNaN(value)) {
      return this.defaultValue;
    }
    return this.colorFunction ? this.colorFunction(value).hex() : this.defaultValue;
  }
}
